import { Locale, ar, bg, de, enGB, es, fr, he, id, it, ja, nb, nl, pl, pt, ro, ru, sv, th, tr, uk, vi, ko, zhTW } from 'date-fns/locale';

export const localeMap: Record<string, Locale> = {
	ar,
	bg,
	'en-GB': enGB,
	id,
	jp: ja,
	pt,
	es,
	de,
	fr,
	it,
	he,
	sv,
	ro,
	tr,
	pl,
	nl,
	ru,
	uk,
	vi,
	th,
	ko,
	zh: zhTW,
	no: nb,
};

export const DEFAULT_LANGUAGE = 'en';

// Banner-visibility ONLY (custom CookieNotice). NOT a Consent Mode scope — see
// consentRequiredRegions (TPD-573 A12 split these two responsibilities).
export const cookieCountries = ['FR', 'MD'];

// Consent Mode region scope (TPD-573 A11/A12): regions where consent is legally
// required, so the code-owned default denies storage until the CMP grants it.
// EEA (EU-27 + IS/LI/NO) + UK + Switzerland. ISO-3166-1 alpha-2.
export const consentRequiredRegions = [
	'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU',
	'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES',
	'SE', 'IS', 'LI', 'NO', 'GB', 'CH',
];

export const DEFAULT_LOCALE = 'en-GB';

export enum TripType {
	ROUND_TRIP = 'round-trip',
	ONE_WAY = 'one-way',
}

export type ItemType = {
	label: string;
	value: string;
	icon?: string;
};

export const tripTypes: ItemType[] = [
	{
		label: 'keywords.roundTrip',
		value: 'round-trip',
	},
	{
		label: 'keywords.oneWay',
		value: 'one-way',
	},
];
export const pricingTypes = [
	{
		label: 'keywords.economy',
		value: 'economy',
	},
	{
		label: 'keywords.business',
		value: 'business',
	},
	{
		label: 'keywords.first',
		value: 'first',
	},
	{
		label: 'keywords.premium',
		value: 'premium',
	},
];

export const roomTypes: ItemType[] = [
	{
		label: 'main.hotels.onePerson',
		value: 'one-person',
		icon: 'icon-one-person',
	},
	{
		label: 'main.hotels.twoPerson',
		value: 'two-person',
		icon: 'icon-two-persons',
	},
	{
		label: 'main.hotels.family',
		value: 'family',
		icon: 'icon-family',
	},
];

export const childrenAges = [
	{ value: 0, label: 'Under 1' },
	{ value: 1, label: '1' },
	{ value: 2, label: '2' },
	{ value: 3, label: '3' },
	{ value: 4, label: '4' },
	{ value: 5, label: '5' },
	{ value: 6, label: '6' },
	{ value: 7, label: '7' },
	{ value: 8, label: '8' },
	{ value: 9, label: '9' },
	{ value: 10, label: '10' },
	{ value: 11, label: '11' },
	{ value: 12, label: '12' },
	{ value: 13, label: '13' },
	{ value: 14, label: '14' },
	{ value: 15, label: '15' },
	{ value: 16, label: '16' },
	{ value: 17, label: '17' },
];

export const JP_DATE_FORMAT = 'M月 d日 (EEE)';
export const ID_DATE_FORMAT = 'd MMM (EEE)'; // Indonesian: day before month
export const ZH_DATE_FORMAT = 'EEE, M月d日'; // Chinese: weekday + month/day with 日 suffix
export const DATE_FORMAT = 'EEE, MMM d';

export const DEFAULT_PROVIDER = 'kayak';
export const DEFAULT_TAB = 'front';
